import axios from 'axios'
import store from '../../store'
import ElementUI from 'element-ui'
import router from '../router'
export function request (config) {
  const instance = axios.create({
    baseURL: '/',
    timeout: 10000
  })
  instance.interceptors.request.use(
    config => {
      // 如果登录了携带标头为0
      if (store.getters.Flag && localStorage.getItem('Flag')) {
        config.headers['Flag'] = '0'
      } else {
        config.headers['Flag'] = '1'
      }
      return config
    },
    error => {
      return Promise.reject(error)
    })
  instance.interceptors.response.use(
    response => {
      if (store.getters.Flag && localStorage.getItem('Flag')) {
        if (response.data.flag === 1) {
          store.commit('Flag', null)
          localStorage.removeItem('Flag')
          store.commit('proxy', null)
          localStorage.removeItem('proxy')
          ElementUI.Message.error('登录失效')
          router.push('/home')
        }
      }
      return response
    },
    error => {
      if (error.response.status === 500) {
        // 没登录全删除
        // store.commit('Flag', null)
        // localStorage.removeItem('Flag')
        // store.commit('proxy', null)
        // localStorage.removeItem('proxy')
        ElementUI.Message.error('网络异常')
        router.push('/home')
      }
      return Promise.reject(error)
    })
  return instance(config)
}



// WEBPACK FOOTER //
// ./src/network/request.js